// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 352) return "static/chunks/352-1d028296b842bcb6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"656":"c7232f79b9502c26","835":"b07c4c1c6fe904b7"}[chunkId] + ".js";
};